export default __webpack_public_path__ + "static/media/vision.e6cfac35.svg";